var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobTitle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "64 64 896 896",
    focusable: "false",
    "data-icon": "press",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icon_Job_title_data_management"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_Job_title_data_management",
    "data-name": "icon_Job title data management",
    clipPath: "url(#clip-icon_Job_title_data_management)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 411.565,
    height: 56,
    rx: 8,
    transform: "translate(267.306 257.707)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 411.565,
    height: 56,
    rx: 8,
    transform: "translate(267.306 395.891)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 205.783,
    height: 56,
    rx: 8,
    transform: "translate(267.306 534.076)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M864.36,914.876a152.042,152.042,0,0,0-125.03-146.77,129.88,129.88,0,1,0-139.19-.21,152.038,152.038,0,0,0-126.27,149.83v9.44c0,2.66.07,5.29.2,7.91h57.45c-.09-1.76-.14-3.53-.14-5.32V923.1a107.232,107.232,0,0,1,107.23-107.23h61.03a107.231,107.231,0,0,1,107.21,105.22c.01.66.02,1.34.02,2.01v11.98h57.52v-17.35C864.39,916.776,864.38,915.816,864.36,914.876ZM669.9,732.206a73.88,73.88,0,1,1,73.88-73.88A73.967,73.967,0,0,1,669.9,732.206Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M863.61,896.266v2.85c0-.95-.01-1.91-.03-2.85Z",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M791.784,88.924H167.61a8,8,0,0,0-8,8V927.076a8,8,0,0,0,8,8H424.349a8,8,0,0,0,8-8v-40a8,8,0,0,0-8-8H215.61V144.924H743.784v328a8,8,0,0,0,8,8h40a8,8,0,0,0,8-8v-376A8,8,0,0,0,791.784,88.924Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobTitle);
export default __webpack_public_path__ + "static/media/JobTitle.1f4509dd.svg";
export { ForwardRef as ReactComponent };